import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/gruh-udhyog/index";

export const Route = createFileRoute(
  "/admin/_modules/_gruh-udhyog/gruh-udhyog"
)({
  component: Page,
});
